export default __webpack_public_path__ + "static/media/numpy-logo.e853e8fd.svg";